import React, { useState } from 'react';
import { Field, useFormikContext } from 'formik';

import { InputUI, FormErrorUI, FormLabelUI, AutoCompleteSelectUI, CheckboxUI, IconPaletteUI } from '../Interface';
import { getIcon } from '../../utils/helper';
import { IconButton } from '@mui/material';

export const FavouriteMenusFields = ({ viewField, menuData }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    if (!viewField) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleIconSelect = (iconName) => {
    setFieldValue('icon', iconName);
    handlePopoverClose();
  };

  return (
    <div className="grid grid-cols-5 gap-x-4 mx-4 mb-5">
      <div className="col-span-5 md:col-span-2">
        <Field
          type="autocomplete"
          name="subMenuUrl"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Felület" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.subMenuUrl} />}
          onChange={(_e, newVal) => {
            setFieldValue('subMenuUrl', newVal?.value ?? null).then(() => {
              validateField('subMenuUrl');
            });

            if (!values.name) {
              setFieldValue('name', newVal?.label);
            }
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.subMenuUrl !== '' }}
          selectedValue={values.subMenuUrl}
          dataset={menuData}
        />
      </div>
      <div className="col-span-5 md:col-span-3">
        <Field
          type="text"
          name="name"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Megnevezés" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.name} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.name && values.name !== '' }}
        />
      </div>
      <div className="md:col-span-1 col-span-4 pt-4">
        <div onClick={handlePopoverOpen} className="flex gap-3 cursor-pointer items-center">
          <IconButton sx={{ margin: 0, padding: 0 }}>{getIcon(values?.icon, '1.7rem')}</IconButton>
          Ikon
        </div>
        <IconPaletteUI
          handleIconSelect={handleIconSelect}
          anchorEl={anchorEl}
          handlePopoverClose={handlePopoverClose}
        />
      </div>
      <div className="md:col-span-2 col-span-4 pt-2">
        <Field
          name="showOnHomePage"
          type="checkbox"
          as={CheckboxUI}
          fullWidth
          label={<FormLabelUI text="Kezdőképernyő megjelenés" />}
          disabled={viewField}
        />
      </div>
      <div className="md:col-span-2 col-span-4 pt-2">
        <Field
          name="showOnNavbar"
          type="checkbox"
          as={CheckboxUI}
          fullWidth
          label={<FormLabelUI text="Fejléc megjelenés" />}
          disabled={viewField}
        />
      </div>
      <div className="md:col-span-2 col-span-4 pt-2">
        <Field
          name="showOnPhone"
          type="checkbox"
          as={CheckboxUI}
          fullWidth
          label={<FormLabelUI text="Telefonon megjelenés" />}
          disabled={viewField}
        />
      </div>
      <div className="col-span-5 md:col-span-1">
        <Field
          type="number"
          name="phoneVisOrder"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Telefon sorrend" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.phoneVisOrder} />}
          disabled={viewField || !values.showOnPhone}
          InputLabelProps={{ shrink: values.phoneVisOrder && values.phoneVisOrder !== '' }}
        />
      </div>
    </div>
  );
};
